import axios from "axios";
import Cookies from "js-cookie";
import { GeneratePublicToken } from "../utils/GeneratePublicToken";

const token = () => Cookies.get("accessToken");

export const verifyPurchase = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  try {
    const header = isLogin
      ? { Authorization: `Bearer ${token()}` }
      : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/checkout-transaction`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }

  //this is the body
  //{
  // "data": {
  //     "payment_method_id": 1,
  //     "shipping_method_id": 1,
  //     "shipping_method_name": "MPI",
  //     "shipping_price": 0,
  //     "note": "test",
  //     "fee": 11,
  //     "ppn": 11,
  //     "total_transaction": 72000,
  //     "uuid": "machine-id"
  // },
  // "action_type": 1,
  // "cart":[
  //     {
  //         "company_id": 1069,
  //         "product_type": 0,
  //         "product_id": 12581,
  //         "product_name": "33 Malaya Madu Hitam Pahit Super",
  //         "quantity": 1,
  //         "price": 72000
  //     }
  // ]
  //}
};

export const getTransactionList = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/transactions${
        isLogin ? "-jwt" : ""
      }`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }

  //this is the body
  //     {
  //     "offset": 1,
  //     "limit": 10,
  //     "start_date": "",
  //     "end_date": "",
  //     "status": 10,
  //     "search": ""
  // }
};

export const getTransaction = async (no_order) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/transaction?no_order=${no_order}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const checkPayment = async (invoice) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const machineId = localStorage.getItem("MachineId");
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };
  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/check-payment${
        isLogin ? "-jwt" : ""
      }?invoice=${invoice}&uuid=${machineId ? machineId : ""}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getInvoice = async (payment_number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/invoice?payment_number=${payment_number}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const updateTransaction = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/update-status`,
      method: "PUT",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

// "user_info": {
//           "fullname": "Farhan Kebab",
//           "address": "6285454346616 Kebayoran Lama, jalan raya Grogol Selatan, DKI Jakarta, 12220"
//       },
//       "payment_info": {
//           "payment_method_name": "Mandiri Virtual Account",
//           "shipping_method_name": "MPI",
//           "status_trx": 5
//       },
//       "invoice_product": [
//           {
//               "order_number": "INV-07032409035274952087",
//               "product_name": "3M MICROPORE Surgical Tape",
//               "fullname": "Farhan Kebab",
//               "address": "6285454346616 Kebayoran Lama, jalan raya Grogol Selatan, DKI Jakarta, 12220",
//               "quantity": 1,
//               "price": 12000,
//               "company_id": 1411
//           },
//           {
//               "order_number": "INV-07022402545178727605",
//               "product_name": "3M MICROPORE Surgical Tape",
//               "fullname": "Farhan Kebab",
//               "address": "6285454346616 Kebayoran Lama, jalan raya Grogol Selatan, DKI Jakarta, 12220",
//               "quantity": 2,
//               "price": 43000,
//               "company_id": 934
//           },
//           {
//               "order_number": "INV-07022402545178727605",
//               "product_name": "3M MICROPORE Surgical Tape 1.25×9.1",
//               "fullname": "Farhan Kebab",
//               "address": "6285454346616 Kebayoran Lama, jalan raya Grogol Selatan, DKI Jakarta, 12220",
//               "quantity": 2,
//               "price": 13000,
//               "company_id": 934
//           }
//       ]
//   }

export const getTransactionListJwt = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/transactions-jwt`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getDetailTransactionJwt = async (noOrder) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/transaction?no_order=${noOrder}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const checkPaymentTransactionJwt = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/check-payment-jwt?invoice=${body.inv_number}&uuid=${body.uuid}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const verifyPurchaseConsultation = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/consultations`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const checkPaymentConsultation = async (invNumber) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/consultation-check-payment?invoice=${invNumber}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const transactionStatusDone = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/transaction-done?transaction_id=${body.transaction_id}`,
      method: "POST",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};